import axios from "axios";
import { loadLanguageAsync } from "../lang/setup/i18n-setup";
import Vue from "vue";
import StratumNotify from "../utils/stratum_notify";
import { endpoints } from "../configs/global";
Vue.use(StratumNotify);
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.put["Content-Type"] = "application/json";

let notifier = new Vue();
export default {
  logout(context, logoutType) {
    context.commit("setAuthorized", false);
    context.commit("deleteAuthCookie");
    notifier.notifyWarning(logoutType, 5000);

    setTimeout(() => {
      window.location.reload();
    }, 2000);
  },
  setLanguageSelected(context, lang) {
    context.commit("setLanguageSelected", lang);
    loadLanguageAsync(lang);
  },

  async getAccountSelected(context, coinSymbol) {
    let accounts = "";
    try {
      let resp = await context.dispatch("getAccounts");
      accounts = resp.data;
      context.commit("setAccounts", accounts);

      console.log('aquiii ó')

      accounts.forEach(element => {
        if (element.currency.symbol == "ETH") {
          context.commit("setEthAccount", element);
        }
        if (element.currency.symbol == "REALT") {
          context.commit("setRealtAccount", element);
        }
        if (element.currency.symbol == "BTC") {
          context.commit("setBtcAccount", element);
        }
        if (element.currency.symbol == "BLU") {
          context.commit("setBluAccount", element);
        }

        // console.log(element)
        if (element.currency.symbol == "USDT") {
          console.log(element, 'aqq')
          context.commit("setUsdtAccount", element);
        }
      });

      if (accounts) {
        let accountSelected = accounts.find(item => {
          return item.currency.symbol === coinSymbol;
        });
        return accountSelected;
      } else {
        return {};
      }
    } catch (e) {
      throw e;
    }
  },

  async updateBluAccount(context) {
    try {
      let bluAccount = await context.dispatch("getAccountSelected", "BLU");
      context.commit("setBluAccount", bluAccount);
    } catch (e) {
      throw e;
    }
  },

  async updateUsdtAccount(context) {
    try {
      let usdtAccount = await context.dispatch("getAccountSelected", "USDT")
      context.commit("setUsdtAccount", usdtAccount)
    } catch (e) {
      throw e
    }
  },

  async getBtcAccount(context) {
    try {
      let btcAccount = await context.dispatch("getAccountSelected", "BTC");
      return btcAccount;
    } catch (e) {
      throw e;
    }
  },

  async getFundTails(context, params) {
    return await publicGetRequest(
      context,
      "/fund?" +
      "offset=" +
      params.offset +
      "&limit=" +
      params.limit +
      "&entryType=" +
      params.entryType
    );
  },

  async getFundTails(context, params) {
    return await publicGetRequest(
      context,
      "/fund?" +
      "offset=" +
      params.offset +
      "&limit=" +
      params.limit +
      "&entryType=" +
      params.entryType
    );
  },

  async getFundTailsBtc(context) {
    let resp = await publicGetRequest(
      context,
      "/fund?offset=0&limit=10&entryType=live&convert=BTC"
    );
    context.commit("setFundValueBtc", resp.data[0]);
  },

  async getCertificateByTypeId(context, params) {
    return await authGetRequestOS(
      context,
      "/purchase/certificate/generate/" + params.type + "/" + params.id
    );
  },

  async getAssetsTail(context, params) {
    return authGetRequest(
      context,
      "/assets?" +
      "offset=" +
      params.offset +
      "&limit=" +
      params.limit +
      "&entryType=" +
      params.entryType
    );
  },

  genericMail(context, body) {
    return publicPostRequest(context, "/mail/generic/sent", body);
  },

  postSignup(context, form) {
    return publicPostRequest(context, "/signup", form);
  },
  postSignin(context, form) {
    return publicPostRequest(context, "/signin", form);
  },
  postRecoverUid(context, form) {
    return publicPostRequest(context, "/recover/uid", form);
  },
  postRecoverPassword(context, form) {
    return publicPostRequest(context, "/recover/password", form);
  },
  postBuyToken(context, form) {
    return authPostRequest(context, "/purchase", form);
  },
  postConfirmBuyToken(context, form) {
    return authPutRequest(context, "/purchase/confirm", form);
  },
  postEmail(context, form) {
    return authPostRequest(context, "/messages/mail/send", form);
  },

  postBlueRewardRequest(context, form) {
    return authPostRequest(context, "/reward/request", form);
  },

  postGenericEmail(context, form) {
    return publicPostRequest(context, "/mail/generic/sent", form);
  },

  postRedeemPreview(context, form) {
    return authPostRequest(context, "/redeem/preview", form);
  },

  postWithdrawPreview(context, form) {
    return authPostRequest(context, "/withdraw/preview", form);
  },

  postWithdrawInternal(context, form) {
    return authPostRequest(context, "/withdraw/internal", form);
  },

  postWithdrawSmartpay(context, form) {
    return authPostRequest(context, "/withdraw/smartpay", form);
  },

  postPurchasePreview(context, form) {
    return authPostRequest(context, "/purchase/preview", form);
  },

  postRedeem(context, form) {
    return authPostRequest(context, "/redeem", form);
  },

  postWithdraw(context, form) {
    return authPostRequest(context, "/withdraw", form);
  },

  putRedeemConfirm(context, form) {
    return authPutRequest(context, "/redeem/confirm", form);
  },

  putWithdrawConfirm(context, form) {
    return authPutRequest(context, "/withdraw/confirm", form);
  },

  async postTrade(context, form) {
    return await authPostRequest(context, "/purchase", form);
  },
  async getTrade(context) {
    return await authGetRequest(context, "/trade/tracking/purchase");
  },

  async getTradeSearchByTradeId(context, trade_id) {
    return await authGetRequest(
      context,
      `/trade/trackings/seller/search?limit=1&offset=0&trade_id=${trade_id}`
    );
  },

  async getAccountsVersions(context) {
    return await authGetRequest(context, "/accounts/versions/me");
  },

  async getTradeType(context, type) {
    return await authGetRequest(context, "/trade/tracking/" + type);
  },

  async getRewards(context) {
    return await authGetRequest(context, "/rewards");
  },
  async getPurchases(context) {
    return await authGetRequest(context, "/purchases");
  },




  async getActivePool(context) {
    return await publicGetRequest(context, "/pools");
  },

  async getPoolsSumarry(context) {
    return await publicGetRequest(context, "/pools/summary");
  },

  async postPurchasePixGenerate(context, body) {
    return await authPostRequest(context, "/purchase/pix/generate", body)
  },


  async postPurchaseCurrencyBalance(context, body) {
    return await authPostRequest(context, "/purchase/cripto/balance", body)
  },

  async getPoolsSummaryByDate(context, params) {
    return await publicGetRequest(context, `/pools/summary?startDate=${params.startAt}&endDate=${params.endAt}`)
  },

  async joinPool(context) {
    return context.commit("setJoinPool", true);
  },

  async getPoolUser(context) {
    return await authGetRequest(context, "/pools/me");
  },

  async addMemberToPool(context, params) {
    return await authPostRequest(context, "/pools/member", params);
  },

  async postSellerPurchase(context, body) {
    return await authPostRequest(context, "/seller/purchase", body);
  },

  async getMemberByUID(context, uid) {
    return authGetRequest(context, `/members/search?uid=${uid}`);
  },

  async putPurchaseCancel(context, purchaseID) {
    return await authPutRequest(context, `/purchase/cancel/${purchaseID}`);
  },

  async putChangeInfo(context, body) {
    return await authPutRequest(context, `/change/info/confirm`, body);
  },

  async putChangePassword(context, body) {
    return await authPutRequest(context, `/change/password/confirm`, body);
  },

  async putChangeNotifyOn(context) {
    return await authPutRequest(context, `/members/notify/on`);
  },

  async putChangeNotifyOff(context) {
    return await authPutRequest(context, `/members/notify/off`);
  },

  async getDeposits(context) {
    return await authGetRequest(context, "/deposits");
  },

  async getWithdraws(context) {
    return await authGetRequest(context, "/withdraws");
  },

  async getRedeems(context) {
    return await authGetRequest(context, "/redeems");
  },

  async getNotificationList(context) {
    return await authGetRequest(context, "/notification/list");
  },

  async getNotificationAnswers(context) {
    return await authGetRequest(context, "/notification/answers");
  },

  async postNotificationConfirm(context, id) {
    return await authPostRequest(context, "/notification/confirm", id);
  },

  async getRedeemInfo(context) {
    return await publicGetRequest(context, "/redeems/info");
  },

  async putAcceptTerms(context) {
    return await authPutRequest(context, "/accept/terms");
  },

  async putAcceptPrivacy(context) {
    return await authPutRequest(context, "/accept/privacy");
  },

  putRedeem(context, id) {
    return authPutRequest(context, "/redeem/cancel/" + id);
  },

  getPurchaseById(context, purchaseID) {
    return authGetRequest(context, "/purchase/" + purchaseID);
  },
  async getMaintenanceStatus(context) {
    let maintenance = await publicGetRequest(context, "/fund/maintenance");
    return maintenance.data;
  },

  putRecoverPasswordConfirm(context, form) {
    return publicPutRequest(context, "/recover/password/confirm", form);
  },
  putActivateMember(context, activationCode) {
    return publicPutRequest(context, "/members/activate/" + activationCode);
  },
  putChangePasswordConfirm(context, form) {
    return authPutRequest(context, "/change/password/confirm", form);
  },
  putCancelPurchase(context, id) {
    return authPutRequest(context, "/purchase/cancel/" + id);
  },
  async getMember(context) {
    try {
      let resp = await authGetRequest(context, "/me");
      context.commit("setMember", resp.data);
      return resp.data;
    } catch (e) {
      throw e;
    }
  },

  getWithdrawById(context, id) {
    return authGetRequest(context, `/withdraw/${id}`);
  },

  getMemberSimple(context) {
    return authGetRequest(context, "/me");
  },

  getOtpCode(context) {
    return authGetRequest(context, "/otp/code");
  },

  getOtpStatus(context) {
    return authGetRequest(context, "/otp/status");
  },

  async getPinGenerate(context, address) {
    return authGetRequest(context, `/pin/generate/${address}`);
  },

  async postCreateAddress(context) {
    return await authPostRequest(context, "/accounts/create/address");
  },

  async postCreateWallet(context) {
    return await authPostRequest(context, "/accounts/create/wallet");
  },

  async getOtpImage(context) {
    return await authGetRequestOS(context, "/otp/image");
  },

  postOptConfirm(context, params) {
    return authPostRequest(context, "/otp/confirm", params);
  },

  postPinGenerate(context, params) {
    return authPostRequest(context, "/otp/validation", params);
  },

  getAccounts(context) {
    return authGetRequest(context, "/accounts");
  },

  async getRewardCheck(context) {
    return authGetRequest(context, "/reward/check");
  },

  async getFees(context) {
    return await publicGetRequest(context, "/taxes");
  },

  async getFeesFilter(context) {
    try {
      let resp = await publicGetRequest(context, "/taxes");
      let redeemFee = resp.data.filter(fee => {
        if (fee.createdAt) {
          return fee.type == "redeem";
        }
      });

      let redeemPurchase = resp.data.filter(fee => {
        if (fee.createdAt) {
          return fee.type == "purchase";
        }
      });

      redeemFee.sort((a, b) => {
        if (a.startAt > b.startAt) return 1;
        if (a.startAt < b.startAt) return -1;
        return 0;
      });

      redeemPurchase.sort((a, b) => {
        if (a.startAt > b.startAt) return 1;
        if (a.startAt < b.startAt) return -1;
        return 0;
      });

      let feePurchase = redeemPurchase[redeemPurchase.length - 1];
      let feeRedeem = redeemFee[redeemFee.length - 1];

      if (!context.getters.feeRedeem) {
        context.commit("setFeeRedeem", feeRedeem);
      }

      if (!context.getters.feePurchase) {
        context.commit("setFeePurchase", feePurchase);
      }
    } catch (e) {
      console.log("could not load fees: ", e);
    }
  },

  getTransactions(context) {
    return authGetRequest(context, "/transactions");
  },
  getTransactionsByType(context, transactionType) {
    return authGetRequest(
      context,
      "/transactions/search?type=" + transactionType
    );
  },

  async getPricePercentChange(context, params) {
    return publicGetRequest(
      context,
      "/currencies/price/percent_changes?pair=" +
      params.pair +
      "&symbols=" +
      params.symbols
    );
  },

  async getCurrencyByPair(context, pair) {
    return publicGetRequest(context, "/currencies?pair=" + pair);
  },

  getCurrencies(context) {
    if (!context.getters.currencies) {
      context.dispatch("updateCurrencies");
      setInterval(() => {
        context.dispatch("updateCurrencies");
        // }, 5 * 60 * 1000)
      }, 80000);
    }
  },
  async updateCurrencies(context) {
    try {
      let resp = await publicGetRequest(context, "/currencies");

      let btc = resp.data.filter(currency => {
        return currency.symbol == "BTC";
      });
      let blu = resp.data.filter(currency => {
        return currency.symbol == "BLU";
      });
      let eth = resp.data.filter(currency => {
        return currency.symbol == "ETH";
      });

      let zar = resp.data.filter(currency => {
        return currency.symbol == "ZAR";
      });

      let eur = resp.data.filter(currency => {
        return currency.symbol == "EUR";
      });
      let gbp = resp.data.filter(currency => {
        return currency.symbol == "GBP";
      });

      let chf = resp.data.filter(currency => {
        return currency.symbol == "CHF";
      });

      let cny = resp.data.filter(currency => {
        return currency.symbol == "CNY";
      });
      let hkd = resp.data.filter(currency => {
        return currency.symbol == "HKD";
      });
      let xem = resp.data.filter(currency => {
        return currency.symbol == "XEM";
      });

      let ras = resp.data.filter(currency => {
        return currency.symbol == "RAS";
      });

      let cad = resp.data.filter(currency => {
        return currency.symbol == "CAD";
      });

      let aud = resp.data.filter(currency => {
        return currency.symbol == "AUD";
      });

      let usdt = resp.data.filter(currency => {
        return currency.symbol == "USDT";
      });

      context.commit("setBluValue", blu);
      context.commit("setBtcValue", btc);
      context.commit("setEthValue", eth);
      context.commit("setXemValue", xem);
      context.commit("setZarValue", zar);
      context.commit("setEurValue", eur);
      context.commit("setGbpValue", gbp);
      context.commit("setChfValue", chf);
      context.commit("setCnyValue", cny);

      context.commit("setRasValue", ras);
      context.commit("setCadValue", cad);
      context.commit("setAudValue", aud);

      context.commit("setHkdValue", hkd);
      context.commit("setUsdtValue", usdt);

      context.commit("setCurrencies", resp.data);
    } catch (e) {
      throw e;
    }
  },

  getSurveyPrototype(context) {
    return authGetRequest(context, "/survey/prototype");
  },

  async getSurveyPrototypes(context) {
    return await publicGetRequest(context, "/survey/prototypes");
  },

  postSurveyPrototype(context, params) {
    return authPostRequest(context, "/survey/prototype", params);
  },

  getDepositById(context, depositID) {
    return authGetRequest(context, "/deposit/" + depositID);
  },

  getRewardById(context, rewardID) {
    return authGetRequest(context, "/rewards/" + rewardID);
  },
  getBonusById(context, bonusID) {
    return authGetRequest(context, "/bonus/" + bonusID);
  },
  getBalances(context) { },
  getRecentTransactions(context) { },

  getReferrals(context) {
    return authGetRequest(context, "/transactions/search?type=rewards");
  },
  getTransactionDataById(context, transaction) {
    return authGetRequest(
      context,
      "/" + transaction.type + "/" + transaction.id
    );
  },

  getCurrenciesHistory(context, params) {
    return publicGetRequest(
      context,
      "/currencies/history?start=" +
      params.start +
      "&end=" +
      params.end +
      "&pair=" +
      params.pair +
      "&period=" +
      params.period +
      "&symbols=" +
      params.sumbols
    );
  },

  postBankSlip(context, params) {
    return authPostRequest(context, "/bankslip", params);
  }
};

async function publicPostRequest(context, uri, form) {
  return baseRequest(context, "post", uri, form, false);
}

async function publicGetRequest(context, uri, form) {
  return baseRequest(context, "get", uri, form, false);
}

async function publicPutRequest(context, uri, form) {
  return baseRequest(context, "put", uri, form, false);
}

async function authPostRequest(context, uri, form) {
  return baseRequest(context, "post", uri, form, true);
}

async function authPutRequest(context, uri, form) {
  return baseRequest(context, "put", uri, form, true);
}
async function authGetRequest(context, uri, form) {
  return baseRequest(context, "get", uri, form, true);
}

async function authGetRequestOS(context, uri, form) {
  return baseRequestOS(context, "get", uri, form, true);
}

async function baseRequest(context, method, uri, form, authenticated) {
  // publicBackendUrl: "172.16.17.124:84",
  // restrictBackendUrl: "172.16.17.124:85",
  try {
    let data = {};
    if (form) {
      data = JSON.stringify(form);
    }
    let prefix = "";
    if (window.location.origin.includes("www")) {
      prefix = "www.";
    }
    let url;
    if (authenticated) {
      url =
        endpoints.protocol +
        "//" +
        prefix +
        endpoints.backendUrl +
        "/api/restrict" +
        uri;
    } else {
      url =
        endpoints.protocol +
        "//" +
        prefix +
        endpoints.backendUrl +
        "/api/public" +
        uri;
    }

    let headers = {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      "Access-Control-Allow-Origin": "*"
    };
    let withCredentials = false;
    if (authenticated) {
      if (!context.getters.authCookie) {
        context.dispatch("logout", this.$t("msg.session_expired"));
      }
      headers = {
        "x-token": context.getters.authCookie,
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        "Access-Control-Allow-Origin": "*"
      };
      withCredentials = true;
    }
    const resp = await axios({
      method: method,
      url: url,
      data: data,
      headers: headers,
      withCredentials: withCredentials
    });
    // console.log(resp)
    return resp;
  } catch (error) {
    if (error.response) {
      if (error.response.data) {
        // console.log(error.response.data);
        if (error.response.status === 401) {
          //token expired
          context.dispatch("logout", "Session expired. Please log in again");
        }

        throw new Error(error.response.data.message);
      }
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      if (!error.status) {
        console.log(error);
      }
      // throw new Error(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      throw new Error(error.message);
    }
    throw error;
  }
}

async function baseRequestOS(context, method, uri, form, authenticated) {
  try {
    let data = JSON.stringify(form);
    let prefix = "";
    if (window.location.origin.includes("www")) {
      prefix = "www.";
    }
    // const url = endpoints.protocol + "//" + prefix + endpoints.backendUrl + "/blue" + uri;
    let url;
    if (authenticated) {
      url =
        endpoints.protocol +
        "//" +
        prefix +
        endpoints.backendUrl +
        "/api/restrict" +
        uri;
    } else {
      url =
        endpoints.protocol +
        "//" +
        prefix +
        endpoints.backendUrl +
        "/api/public" +
        uri;
    }
    let headers = { "Content-Type": "application/octet-stream" };
    let withCredentials = false;
    if (authenticated) {
      if (!context.getters.authCookie) {
        context.dispatch("logout", "Session expired. Please log in again");
      }
      headers = {
        Accept: "application/octet-stream",
        "Content-Type": "application/octet-stream",
        "x-token": context.getters.authCookie
      };
      withCredentials = true;
    }
    const resp = await axios({
      method: method,
      url: url,
      data: {},
      headers: headers,
      responseType: "blob",
      withCredentials: withCredentials
    });
    // console.log(resp)
    return resp;
  } catch (error) {
    if (error.response) {
      if (error.response.data) {
        // console.log(error.response.data);
        if (error.response.status === 401) {
          //token expired
          context.dispatch("logout", "Session expired. Please log in again");
        }
        throw new Error(error.response.data.message);
      }
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      if (!error.status) {
        console.log(error);
      }
      // throw new Error(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      throw new Error(error.message);
    }
    throw error;
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js